import axios from "axios";
import { baseUrl } from "../util";

const getConfig = () => ({
  headers: {
    Authorization: `Bearer ${localStorage.getItem("access_token")}`,
    "Content-Type": "application/json",
  },
});

export const linksService = {
  getLinks: async (effortId) => {
    try {
      const response = await axios.get(
        `${baseUrl}/api/business/efforts/${effortId}/links/`,
        getConfig()
      );
      return response.data.data;
    } catch (error) {
      console.error("Error fetching links:", error);
      throw error;
    }
  },

  createLink: async (effortId, linkData) => {
    try {
      const response = await axios.post(
        `${baseUrl}/api/business/efforts/${effortId}/links/`,
        linkData,
        getConfig()
      );
      return response.data.data;
    } catch (error) {
      console.error("Error creating team:", error);
      throw error;
    }
  },

  updateLink: async (effortId, teamId, linkData) => {
    try {
      const response = await axios.put(
        `${baseUrl}/api/business/efforts/${effortId}/links/${teamId}/`,
        linkData,
        getConfig()
      );
      return response.data.data;
    } catch (error) {
      console.error("Error updating team:", error);
      throw error;
    }
  },

  deleteLink: async (effortId, teamId) => {
    try {
      const response = await axios.delete(
        `${baseUrl}/api/business/efforts/${effortId}/links/${teamId}/`,
        getConfig()
      );
      return response.status === 204;
    } catch (error) {
      console.error("Error deleting team:", error);
      throw error;
    }
  },
};
